import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

class ProjectListItem extends Component {

  handleLinkClick = (e) => {
    if (this.props.hideClient) {
      e.preventDefault()
    }
  }

  render () {

    const { project, hideClient } = this.props
    // The hideClient props is used for proposal project when we are not displaying the client and do not want to navigate to the project page

    let className = ''
    if (project.status) {
      className = project.status.toLowerCase().replace(" ","-")
    }

    return (
      <tr id="ProjectListItem"
        className={className}
        style={{verticalAlign: "middle"}}
        onClick={hideClient ? this.props.handleClick : null}
      >
        {hideClient ?
          null
          :
          <td>
            <Link to={`/projects/${project.id}`}
              onClick={this.handleLinkClick}
              style={{display: 'block'}}
            >
              {project.client ? project.client.name : 'N/A'}
            </Link>
          </td>
        }
        <td>
          <Link to={`/projects/${project.id}`}
            onClick={this.handleLinkClick}
            style={{display: 'block'}}
          >
            {project.short_id}-{project.number}
          </Link>
        </td>
        <td>
          <Link to={`/projects/${project.id}`}
            onClick={this.handleLinkClick}
            style={{display: 'block'}}
          >
            {project.title}
          </Link>
        </td>
        {project.status ?
          <td>
            <Link to={`/projects/${project.id}`}
              onClick={this.handleLinkClick}
              style={{display: 'block'}}
            >
              {project.status}
            </Link>
          </td>
          :
          null
        }
      </tr>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user
  }
}

export default connect(mapStateToProps)(ProjectListItem);



// WEBPACK FOOTER //
// ./src/routes/projects/components/ProjectListItem.js